import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatusAttendee } from '@shared/constants/constants';

@Pipe({
    name: 'attendeeStatusType'
})
export class AttendeeStatusTypePipe implements PipeTransform {
    constructor(
        private translation: TranslateService
    ) { }
    transform(value: number): string {
        let result = '';
        const itemsStatusAttendee = StatusAttendee(this.translation);
        if (itemsStatusAttendee){
            const selected = itemsStatusAttendee.find(x => x.id === value);
            if (selected){
                result = selected.text;
            }
        }

        return result;
    }
}
